import React from 'react';
import { OdontoProtectionDetails } from '~/scenes';
import { Stack } from '../stackNavigation';

export const OdontoProtectionNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_OdontoProtectionDetails"
      component={OdontoProtectionDetails}
    />
  </Stack.Group>
);
